module.exports = __webpack_public_path__ + "img/water-droplet-0.0b12ddf0.png";